import React from 'react';
import { Slide } from 'react-reveal';
import Icon from './Icon';
import './Icons.css';

var Icons = (props) => {
    return (
        <div className="icons">
            {props.direction === "left" ?
                <Slide left>
                    <div className="icon-container">
                        {props.source.map(e => (
                            <Icon key={e.name} name={e.name} link={e.link} link_type={e.link_type} classNames={e.classNames} />
                        ))}
                    </div>
                </Slide> :
                <Slide right>
                    <div className="icon-container">
                        {props.source.map(e => (
                            <Icon key={e.name} name={e.name} link={e.link} link_type={e.link_type} classNames={e.classNames} />
                        ))}
                    </div>
                </Slide>
            }
        </div>
    );
}

export default Icons;


// WEBPACK FOOTER //
// ./src/components/Icons/Icons.js